/**
 * localStorage keys for admin wallet linking only.
 */
export const ADMIN_WALLET_STORAGE_KEYS = {
  address: "admin_wallet_address",
  provider: "admin_wallet_provider",
};
